import React from "react";
import { Container, Nav, NavItem, NavLink } from "reactstrap";

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <Container fluid>
        <Nav>
          {/*<NavItem>*/}
          {/*<NavLink href="#">About Us</NavLink>*/}
          {/*</NavItem>*/}
          {/*<NavItem>*/}
          {/*  <NavLink href="#">Lisk HQ</NavLink>*/}
          {/*</NavItem>*/}
          <NavItem>
            V0.9_alpha | Mainnet | This block explorer is not affiliated with
            LiskHQ or Lightcurve
          </NavItem>
        </Nav>
        <div className="copyright">
          © {new Date().getFullYear()} - vote for Carbonara to support this
          project.
          {/*made with{" "}*/}
          {/*<i className="tim-icons icon-heart-2" /> by{" "}*/}
          {/*<a*/}
          {/*  href="#"*/}
          {/*  rel="noopener noreferrer"*/}
          {/*  target="_blank"*/}
          {/*>*/}
          {/*  Carbonara*/}
          {/*</a>{" "}*/}
          {/*for the Lisk Ecosystem.*/}
        </div>
      </Container>
    </footer>
  );
};
